module.exports = __webpack_public_path__ + "static/media/reports_inventory-saved-searches.6b12b35a.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_inventory-saved-searches.md
// module id = 1111
// module chunks = 0